import { StyleSheet } from "react-native";
import { color } from "react-native-reanimated";

const styles = StyleSheet.create({
  cardContainer: {
    marginBottom: 20,
    paddingTop: 20,
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: 12,
    alignSelf: "center",
    width: "90%",
    marginHorizontal: 25,
    borderWidth: 0.5,
    borderColor: "#FFF",
    borderRadius: 8,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 6,
    elevation: 4,
  },

  headerCardTransas: {
    fontSize: 18,
    color: "#077A97",
    fontWeight: "bold",
    marginBottom: 18,
  },

  lbl: {
    fontWeight: "bold",
    flex: 1,
    textAlign: "center",
  },

  lblContainer: {
    marginTop: 18,
    flexDirection: "row",
    width: "100%",
    justifyContent: "space-between",
  },

  hr: {
    alignSelf: "center",
    borderBottomWidth: 1,
    width: "95%",
    marginVertical: 15,
    borderColor: "#077A97",
  },

  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#FFF",
    marginBottom: 12,
    padding: 8,
    borderBottomWidth: 1,
    borderColor: "#077A97",
    width: "100%",
  },

  column: {
    flex: 1,
    alignItems: "center",
  },

  lbl: {
    fontWeight: "bold",
    textAlign: "center",
    color: "#077A97",
  },

  itemText: {
    fontSize: 14,
    color: "#333",
    textAlign: "center",
  },

  subItemText: {
    fontSize: 12,
    color: "#666",
    textAlign: "center",
  },

  btnBack: {
    padding: 10,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#FFF",
    borderWidth: 0.5,
    borderColor: "#077A97",
    marginRight: 6,
  },

  btnNext: {
    padding: 10,
    height: 32,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
  },

  rowBtnsPagination: {
    width: "100%",
    alignSelf: "flex-start",
    marginTop: 12,
    marginBottom: 6,
  },

  paginationContainer: {
    marginTop: 6,
    marginBottom: 20,
  },

  input: {
    flex: 1,
    height: 40,
    borderColor: "#077A97",
    borderWidth: 1,
    borderRadius: 4,
    marginBottom: 10,
    padding: 10,
  },

  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
  },

  searchIcon: {
    position: "absolute",
    right: 10,
    top: 8,
  },
});

export default styles;
